export type Testimonial = {
  quote: string
  author: string
  role: string
  location?: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * Only real reviews from real aerial instructors (with their permission).
 * The review sections only render when these arrays have items.
 */
export const coachProfiles: CoachProfile[] = []

export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I used to spend my evenings trying to figure out what to teach the next day. Having ready-to-use class plans gives me a starting point, so I can spend less time planning from scratch and more time preparing to teach.',
    author: 'Laura Pence',
    location: 'Huntsville, Alabama',
    role: 'Silks, hoop & partner aerial acrobatics',
  },
  {
    quote:
      "When I first started teaching aerial hoop, I wasn't always sure how to structure a full class. Having a clear sequence of activities and progressions helped me organize my sessions with more confidence.",
    author: 'Aimee Polk',
    location: 'Alabama · Aerialogy',
    role: 'Silks & hoop',
  },
  {
    quote:
      'Mixed-level classes can be challenging when everyone needs something different. Having easier and more challenging variations gives me a practical starting point for adapting activities to the group.',
    author: 'Amy Hercules',
    location: 'Takoma Park, Maryland',
    role: 'Silks, lyra & straps',
  },
  {
    quote:
      'Mixed-level classes can be challenging when everyone needs something different. Having easier and more challenging variations gives me a practical starting point for adapting activities to the group.',
    author: 'Linnea Spear',
    location: 'Maryland',
    role: 'Silks & lyra',
  },
  {
    quote:
      'Coming up with fresh class ideas every week can be mentally exhausting. Having a library of class plans and choreography ideas gives me more options to work from when planning my sessions.',
    author: 'James Zavala',
    location: 'Palm Desert, California',
    role: 'Silks, lyra, hammock & trapeze',
  },
  {
    quote:
      'Having the steps laid out helped me see how to build a class around a skill instead of choosing unrelated tricks.',
    author: 'Katie Critzer',
    location: 'Sioux Falls, South Dakota',
    role: 'Silks & trapeze',
  },
]

export const moreTestimonials: Testimonial[] = []

/**
 * Real words from aerial instructors and students on public forums (r/Aerials,
 * as indexed by Google). They describe the problem, they are NOT reviews of this product.
 */
export type ForumQuote = { quote: string; context: string }

export const forumQuotes: ForumQuote[] = [
  {
    quote: 'I am a fairly new instructor, about a year into teaching. I am feeling a bit insecure…',
    context: 'Aerial instructor · public aerial forum',
  },
  {
    quote: 'So I’m to start teaching a beginner class for Lyra but I want some tips first',
    context: 'New lyra instructor · public aerial forum',
  },
  {
    quote: '…a new instructor who favors picking moves off of social media regardless of what skill/strength level…',
    context: 'Aerial student · public aerial forum',
  },
]
